module.exports = __webpack_public_path__ + "static/media/Icon-Delete.0ee6646a.svg";